import React from "react";
import ReactECharts from "echarts-for-react";
import emptyStatePie from "../assets/empty-state-pie.svg";

const Page = ({ title, data, height = "350px", width = "100%" }) => {
  if (data.length === 0) {
    return (
      <div
        className="flex flex-col items-center justify-center"
        style={{
          height,
          width,
        }}
      >
        <img src={emptyStatePie} alt="No Data" className="h-40 w-40" />
        <p className="mt-4 text-slate-500 mx-auto">
          Diversify your investments.
        </p>
      </div>
    );
  }
  const formattedData = data.map((item) => ({
    ...item,
    name: `${item.name} (${item.value.toFixed(1)}%)`,
  }));
  const options = {
    title: {
      text: title,
      left: "center",
    },
    tooltip: {
      trigger: "item",
      formatter: (params) => params.name,
    },
    legend: {
      bottom: 0,
      left: "center",
    },
    series: [
      {
        name: title,
        type: "pie",
        radius: ["50%", "65%"],
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        avoidLabelOverlap: false,
        data: formattedData,
        animation: true,
        animationDuration: 1500, // Duration in milliseconds
        animationEasing: "exponentialInOut", // Easing function
      },
    ],
  };

  return <ReactECharts option={options} style={{ height, width }} />;
};

export default Page;
